/**
 * Auto-hide for status overlay opened via local triple-tap (not Studio/MCP remote).
 * Remote overlays use {@link remoteOverlaySessionLatch} (~15 min) instead.
 */

export const LOCAL_STATUS_OVERLAY_AUTO_HIDE_MS = 5 * 60 * 1000

let hideTimer: ReturnType<typeof setTimeout> | null = null
/** Wall-clock ms when the local auto-hide fires; 0 when not armed. */
let hideUntilMs = 0

export function clearLocalStatusOverlayAutoHide(): void {
  if (hideTimer != null) {
    clearTimeout(hideTimer)
    hideTimer = null
  }
  hideUntilMs = 0
}

export function armLocalStatusOverlayAutoHide(
  onHide: () => void,
  ms: number = LOCAL_STATUS_OVERLAY_AUTO_HIDE_MS,
  nowMs: number = Date.now()
): void {
  clearLocalStatusOverlayAutoHide()
  hideUntilMs = nowMs + ms
  hideTimer = setTimeout(() => {
    hideTimer = null
    hideUntilMs = 0
    onHide()
  }, ms)
}

/** Absolute deadline for the local auto-hide, or 0 when not armed. */
export function getLocalStatusOverlayAutoHideUntilMs(): number {
  return hideUntilMs
}

export function isLocalStatusOverlayAutoHideArmedForTests(): boolean {
  return hideTimer != null
}

/** Test helper. */
export function resetLocalStatusOverlayAutoHideForTests(): void {
  clearLocalStatusOverlayAutoHide()
}
